import script from "./TreeCardapio.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeCardapio.vue?vue&type=script&setup=true&lang=js"

import "./TreeCardapio.vue?vue&type=style&index=0&id=784c0566&lang=css"

const __exports__ = script;

export default __exports__